import { z } from 'zod';

export const UserRole = z.enum(['admin', 'pm', 'qa', 'surveyor']);
export type UserRole = z.infer<typeof UserRole>;

export const User = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string(),
  role: UserRole,
  is_active: z.boolean(),
});
export type User = z.infer<typeof User>;

export const LoginRequest = z.object({
  email: z.string().email('Invalid email'),
  password: z.string().min(1, 'Password is required'),
});
export type LoginRequest = z.infer<typeof LoginRequest>;

export const LoginResponse = z.object({
  token: z.string(),
  user: User,
});
export type LoginResponse = z.infer<typeof LoginResponse>;
